import { render, staticRenderFns } from "./zixun.vue?vue&type=template&id=693a4954"
import script from "./zixun.vue?vue&type=script&lang=js"
export * from "./zixun.vue?vue&type=script&lang=js"
import style0 from "./zixun.vue?vue&type=style&index=0&id=693a4954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports